import { createApi } from '@reduxjs/toolkit/query/react';
import { baseQuery } from './baseQuery';

/**
 * Main API Service
 * 
 * This is the central API service that uses RTK Query.
 * All endpoints are injected via separate endpoint files for better organization.
 * 
 * To add a new endpoint:
 * 1. Create a new file in services/api/endpoints/
 * 2. Use api.injectEndpoints() to add your endpoints
 * 3. Export the hooks from that file
 */

export const odooApi = createApi({
  reducerPath: 'odooApi',
  baseQuery,
  tagTypes: [
    'User',
    'Department',
    'Post',
    'Tender',
    'Facility',
    'Event',
    'Form',
    'FormSubmission',
    'Talent',
    'Partner',
    'Subsite',
    'Complaint',
    'SecurityClearance',
    'Portfolio',
    'Delegation',
    'Settings',
    'Analytics',
    'Media',
    'Platform',
  ],
  endpoints: () => ({}), // Endpoints are injected via separate files
  // Prevent infinite retries on errors
  refetchOnMountOrArgChange: false,
  refetchOnFocus: false,
  refetchOnReconnect: false,
});

// DON'T import endpoint files here - it causes circular dependencies
// Import them in store.ts instead after odooApi is fully initialized

// DON'T export hooks from here either - they are exported from services/api.ts
// which imports from endpoint files AFTER odooApi is initialized
